var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction---Detail-Card-Outgoing-Awaiting-Authorization",
    transform: "translate(8 5.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9906",
    "data-name": "Path 9906",
    d: "M16,9.032A6.968,6.968,0,1,1,9.032,16,6.969,6.969,0,0,1,16,9.032M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8ZM14.839,19.1h.387V15.226h-.387a.387.387,0,0,1-.387-.387v-.258a.387.387,0,0,1,.387-.387h1.548a.387.387,0,0,1,.387.387V19.1h.387a.387.387,0,0,1,.387.387v.258a.387.387,0,0,1-.387.387H14.839a.387.387,0,0,1-.387-.387v-.258A.387.387,0,0,1,14.839,19.1ZM16,11.355a1.032,1.032,0,1,0,1.032,1.032A1.032,1.032,0,0,0,16,11.355Z",
    transform: "translate(-8 -8)",
    fill: "#00488E",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b183e70b4340e26f8dc992b1a9bcb548.svg";
export { ForwardRef as ReactComponent };